import React, {useEffect, useState} from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  IconButton,
  Fade
} from '@mui/material';
import {HugeiconsIcon} from '@hugeicons/react';
import {Cancel01Icon} from '@hugeicons/core-free-icons';
import {grey} from '@mui/material/colors';
import {toast} from "react-toastify";
import {ContactNumberRepository} from "../../../../repositories/ContactNumberRepository";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 380,
  width: '90%',
  bgcolor: 'background.paper',
  borderRadius: 3,
  border: '0px solid #000',
  boxShadow: 24,
  px: 3,
  py: 3,
};

export const ContactPhoneNumber = ({conversation, open, handleClose, onSaved}) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName(conversation?.senderName || '');
    }
  }, [open, conversation?.id]);

  const handleSave = () => {
    if (!conversation?.id || !name.trim()) return;
    setSaving(true);
    ContactNumberRepository.createOrUpdateByConversation(conversation.id, name.trim())
      .then(response => {
        toast.success("Contact saved");
        onSaved?.(response?.data);
        handleModalClose();
      })
      .catch(error => {
        console.error('Error saving contact:', error);
        toast.error(error?.response?.data?.message || "Failed to save contact");
      })
      .finally(() => setSaving(false));
  };

  const handleModalClose = () => {
    setName('');
    handleClose();
  };

  return (
    <Modal
      open={open}
      aria-labelledby="phone-modal-title"
      aria-describedby="phone-modal-description"
      onClose={handleModalClose}
    >
      <Fade in={open} timeout={500}>
        <Box>
          <Box sx={{position: "fixed", top: 10, right: 10}}>
            <IconButton
              size={"small"}
              onClick={handleModalClose}
              color={"#FFF"}
            >
              <HugeiconsIcon icon={Cancel01Icon} color={grey[300]}/>
            </IconButton>
          </Box>

          <Stack direction={"column"} gap={2} sx={style}>
            <Typography id="phone-modal-title" variant="h6" component="h2">
              {conversation?.senderName ? "Edit Contact" : "Add Contact"}
            </Typography>

            <TextField
              label="Sender"
              variant="outlined"
              fullWidth
              value={conversation?.sender || ''}
              disabled
            />

            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSave();
              }}
              placeholder="Enter contact name"
            />

            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="ghost" onClick={handleModalClose}>
                Cancel
              </Button>
              <Button
                variant="modal"
                onClick={handleSave}
                disabled={!name.trim() || saving}
              >
                Save
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Modal>
  )
}
